import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useEffect, useState } from 'react'
import { HomeActivityStat } from 'src/components/HomeActivityBox/HomeActivityBox'
import HomeActivityEmptyState from 'src/components/HomeActivityBox/HomeActivityEmptyState'
import HomeStatLink, {
  CachedAlertStats,
} from 'src/components/HomeActivityBox/HomeStatLink'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface HomeActionableTasksSectionProps {
  title: string
  testId: string
  loadingProps: {
    loadingState: boolean
  }
  stats: HomeActivityStat[]
  showLoadingState?: boolean
  defaultStatsObject?: CachedAlertStats
  cachedAlertStats?: CachedAlertStats
  setCachedAlertStats?: (stats: CachedAlertStats) => void
  emptyStateLabel?: string
  emptyStateSublabel: string
}

const HomeActionableTasksSection: React.FC<HomeActionableTasksSectionProps> = (
  props,
) => {
  const translate = useTranslate()

  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimedOut(true)
    }, 5000)
    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    if (
      props.setCachedAlertStats &&
      props.defaultStatsObject &&
      !props.loadingProps.loadingState
    ) {
      const cacheObj = Object.keys(props.defaultStatsObject).reduce(
        (acc, key) => {
          return {
            ...acc,
            [key]: props.stats.find((stat) => stat.ariaLabelSource === key)
              ?.statNumber,
          }
        },
        props.defaultStatsObject,
      )
      props.setCachedAlertStats(cacheObj)
    }
  }, [props.loadingProps.loadingState])

  const stats = !props.loadingProps.loadingState
    ? props.stats.filter((stat) => (stat.statNumber || 0) > 0)
    : props.stats

  return (
    <div
      data-testid={props.testId}
      css={css`
        padding: 20px;
        border: 1px solid ${styleConstants.colors.gray_dark};
        border-radius: 12px;
        margin-bottom: 20px;
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.05);
      `}
    >
      <div
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 20px;
        `}
      >
        {translate(props.title)}
      </div>
      {stats.map((stat, index) => (
        <HomeStatLink
          stat={stat}
          index={index}
          key={`HomeStatLink${index}`}
          isLast={index === stats.length - 1}
          showLoadingState={props.showLoadingState}
          cachedStats={props.cachedAlertStats}
          timedOut={timedOut}
          loadingState={props.loadingProps.loadingState}
        />
      ))}
      {stats.length === 0 && (
        <HomeActivityEmptyState
          label={props.emptyStateLabel}
          sublabel={props.emptyStateSublabel}
        />
      )}
    </div>
  )
}

export default HomeActionableTasksSection
